// filepath: /c:/Users/joanr/Desktop/pagina web de blog para adsense/mi-app/src/blog/BlogPost.js
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';
import './BlogPost.css';

const BlogPost = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const docRef = doc(db, 'posts', slug);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setPost(docSnap.data());
        } else {
          console.log('No such document!');
        }
      } catch (error) {
        console.error('Error fetching post: ', error);
      }
    };

    fetchPost();
  }, [slug]);

  if (!post) {
    return <div>Cargando...</div>;
  }

  return (
    <div className="blogpost-container">
      <h1 className="blogpost-title">{post.title}</h1>
      {post.imageUrl && <img src={post.imageUrl} alt={post.title} className="blogpost-image" />}
      <div
        className="blogpost-content"
        dangerouslySetInnerHTML={{ __html: post.content }}
      />
    </div>
  );
};

export default BlogPost;